import gql from 'graphql-tag'

export const IntegrationFragment = gql`
  fragment IntegrationFragment on IntegrationDefinition {
    id
    name
    image
    category
    description
    source
    applications {
      name
      description
      fields {
        name
        value
        required
        generatoable
        readonly
        description
        steps
      }
    }
  }
`
